import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/Corebiltek_logo.png"

function Navbar() {
  return (
    <nav className="site-nav">
      <div className="container">
        <div className="menu-bg-wrap">
          <div className="site-navigation">
            <Link to="/" className="logo m-0 float-start">
              <img src={logo} width={"230px"} alt="CORBILTEK" />
            </Link>
            {/* <Link to="/" className="logo m-0 float-start">
              CORBILTEK
            </Link> */}

            <ul className="js-clone-nav d-none d-lg-inline-block text-start site-menu float-end">
            </ul>

            <a
              href="/"
              className="burger light me-auto float-end mt-1 site-menu-toggle js-menu-toggle d-inline-block d-lg-none"
            >
              <span></span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
